import React from 'react';

import AvatarSelector from '@/home/views/AvatarSelector';
import { LiveMatchOptionsDialog, PrematchMatchOptionsDialog } from '@/matchOptions/MatchOptionsDialog';
import { dialogs } from '@/nikeone/components/dialog/NikeOneDialogs';
import MatchNotifyDialog from '@/notifications/components/MatchNotifyDialog';
import TicketNotifyDialog from '@/notifications/components/TicketNotifyDialog';

import './handlers';
import './subs';
import MessagesPopup from './views/MessagesPopup';
import { LogoutPopup } from './views/LogoutPopup';
import { registerPopups } from './popupRegistrar';
import MessageDialog from './dialogs/MessageDialog';
import Login4Action from './dialogs/Login4Action';
import LoaderDialog from './dialogs/LoaderDialog';
import WarningInfoDialog from './dialogs/WarningInfoDialog';
import InformationDutyOverlay from './informationduty/InformationDutyOverlay';
import TicketPickerDialog from '@/forum/ticketpicker/view/TicketPickerDialog';
import TicketDetailDialog from '@/mytickets/detail/views/TicketDetailDialog';
import TicketOverlay from '@/mytickets/detail/views/TicketOverlay';
import CashinPopup from '@/cashins/views/popup/CashinPopup';
import { ArticleDialog } from '@/article/views/Article';
import ProfileMarketingAgreementModal from '@/myprofile/views/profile/ProfileMarketingAgreementModal';
import { nikeTvDialogs } from '@/nike-tv/views/dialogs/NikeTvDialogs';
import ClosingCashinDialog from '@/cashins/views/popup/ClosingCashinDialog';
import LuckyWheelDialog from '@/luckyWheel/LuckyWheelDialog';
import LuckyWheelConfirmDialog from '@/luckyWheel/LuckyWheelConfirmDialog';
import LuckyWheelRejectDialog from '@/luckyWheel/LuckyWheelRejectDialog';
import ReturnReasonDialog from '@/mytickets/detail/views/Actions/ReturnReasonDialog';
import { TransferFilterDialog } from '@/money/views/TransferFilterDialog';

/* eslint-disable key-spacing */
const popups = {
    'account/logout': () => <LogoutPopup />,
    'dialog/login4action': popup => <Login4Action {...popup.get('data')} />,
    'dialog/message': popup => <MessageDialog {...popup.get('data')} />,
    'dialog/article': popup => <ArticleDialog {...popup.get('data')} />,
    'dialog/warning': popup => <WarningInfoDialog {...popup.get('data')} />,
    'information-duty': popup => <InformationDutyOverlay {...popup.get('data')} />,
    'nikeone/matchoptions/live': popup => <LiveMatchOptionsDialog {...popup.get('data')} />,
    'nikeone/matchoptions/prematch': popup => <PrematchMatchOptionsDialog {...popup.get('data')} />,
    'notifications/matches': popup => <MatchNotifyDialog data={popup.get('data')} />,
    selectAvatar: popup => <AvatarSelector {...popup.get('data')} />,
    'ticket/notification': popup => <TicketNotifyDialog {...popup.get('data')} />,
    'ticketus/cashin-dialog': popup => (
        <CashinPopup
            ticketId={popup.getIn(['data', 'ticketId'])}
            showConfirmDialog={popup.getIn(['data', 'showConfirmDialog'])}
            cashinPosition={popup.getIn(['data', 'cashinPosition'])}
        />
    ),
    'ticketus/cashin-closing': popup => <ClosingCashinDialog {...popup.get('data')} />,
    'ui/loader': popup => <LoaderDialog data={popup.get('data')} />,
    'ui/message': popup => <MessagesPopup popupData={popup.get('data')} />,
    'ticketEditor/popup': popup => <TicketPickerDialog {...popup.get('data')} />,
    'betbook/ticketDetailPopup': popup => <TicketDetailDialog {...popup.get('data')} />,
    'luckyWheel/popup': popup => <LuckyWheelDialog {...popup.get('data')} />,
    'luckyWheelConfirm/popup': popup => <LuckyWheelConfirmDialog {...popup.get('data')} />,
    'luckyWheelConfirmReject/popup': popup => <LuckyWheelRejectDialog {...popup.get('data')} />,
    ticketDetail: popup => <TicketOverlay {...popup.get('data')} />,
    marketingAgreementModal: popup => <ProfileMarketingAgreementModal {...popup.get('data')} />,
    'returnReason/popup': popup => <ReturnReasonDialog {...popup.get('data')} />,
    'transfers/operationFilter': popup => <TransferFilterDialog {...popup.get('data')} />,
    'transfers/timeFilter': popup => <TransferFilterDialog {...popup.get('data')} />,
    ':default': () => null
};
registerPopups(popups);
registerPopups(dialogs);
registerPopups(nikeTvDialogs);
